import { AppearanceSchema } from "@app/components/WidgetStudio/Inspector/schemas/appearance";
import { FunctionsSchema } from "@app/components/WidgetStudio/Inspector/schemas/functions";
import { schemaToJson } from "@app/components/forms/lib/converter";
import { ColorsSchema } from "@app/components/WidgetStudio/Inspector/schemas/colors";

// const basicData = BasicSchema.filter((schema) => schema.type !== 'separator').map(item => item.id);
// const advancedData = AdvancedSchema.filter((schema) => schema.type !== 'separator').map(item => item.id);
//
// const tempWidgetStudioData = [...basicData, ...advancedData];
//
// export const widgetStudioData = tempWidgetStudioData.reduce((acc, cur) => {
//   acc[cur] = '';
//   return acc;
// }, {} as Record<string, string>);
//

// 모양 조건에 따라 타입이 달라질 수 있음
export const WidgetStudioData = schemaToJson([
  ...AppearanceSchema,
  ...ColorsSchema("story"),
  ...FunctionsSchema,
]);
export type WidgetStudioDataType = typeof WidgetStudioData;
